<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>人员管理</el-breadcrumb-item>
        <el-breadcrumb-item>资源管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title-en">鸿云Dcops在库人员</div>
    <el-card class="box-card">
      <fontal-dcops-staff-table :header-style="headerStyle" @edit="handleEdit" @delete="handleDelete"
        @history="handleHistory" />
    </el-card>
    <div class="title-en">1.合作资源人员（外部）</div>
    <el-card class="box-card">
      <staff-resource-table :header-style="headerStyle" @edit="handleEdit" @delete="handleDelete"
        @history="handleHistory" />
    </el-card>

    <div class="title-en">2.专职专项人员（员工）</div>
    <el-card class="box-card">
      <staff-special-table :header-style="headerStyle" @edit="handleEdit" @delete="handleDelete"
        @history="handleHistory" />
    </el-card>

    <div class="title-en">3.计费HC人员（员工）</div>
    <el-card class="box-card">
      <staff-hc-table :header-style="headerStyle" @edit="handleEdit" @delete="handleDelete" @history="handleHistory" />
    </el-card>
  </div>
</template>

<script>
import StaffResourceTable from './components/StaffResourceTable.vue';
import StaffSpecialTable from './components/StaffSpecialTable.vue';
import StaffHcTable from './components/StaffHcTable.vue';
import FontalDcopsStaffTable from './components/FontalDcopsStaffTable.vue';
export default {
  components: {
    StaffResourceTable,
    StaffSpecialTable,
    StaffHcTable,
    FontalDcopsStaffTable
  },
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
    };
  },
  methods: {
    handleEdit(row) {
      console.log('编辑', row);
      // 在这里处理编辑操作
    },
    handleDelete(row) {
      console.log('删除', row);
      // 在这里处理删除操作
    },
    handleHistory(row) {
      console.log('历史记录', row);
      // 在这里处理历史记录操作
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.box-card {
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;

    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }

  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }

  .el-table__header {
    border-color: #fff;
  }

  td.el-table__cell {
    border: 0.5px solid #fff;

    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }

  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }

  tr:hover>td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}

::v-deep .el-table td.el-table__cell .cell {
  white-space: normal !important;
}
</style>